import React from 'react';

import {ControlledAddNodeHandle} from 'ui-library/reactflow/handles/AddNodeHandle';
import {InvisibleNodeHandle} from 'ui-library/reactflow/handles/InvisibleNodeHandle';
import {NodeHandleProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeTypes';
import {defaultNodeHandleIdGenerator} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/sub-components/SimpleBenchlingNodeHandle';

interface TargetEntityNodeHandleProps extends NodeHandleProps {
  handleType: 'target';
}

interface SourceEntityNodeHandleProps extends NodeHandleProps {
  handleType: 'source';
  isFullyExpanded: boolean;
  isExpandable: boolean;
  onClick: () => void;
  tooltipText?: string;
  isHovered: boolean;
  setIsHovered: (isHovered: boolean) => void;
}

export type EntityNodeHandleProps = TargetEntityNodeHandleProps | SourceEntityNodeHandleProps;

export default function EntityNodeHandle(props: EntityNodeHandleProps): JSX.Element {
  if (props.handleType === 'target' || props.isFullyExpanded) {
    return <InvisibleNodeHandle nodeId={props.nodeId} handleType={props.handleType} />;
  }

  return (
    <ControlledAddNodeHandle
      id={defaultNodeHandleIdGenerator(props.nodeId, props.handleType)}
      disabled={!props.isExpandable}
      type={props.handleType}
      isConnectable={false}
      onClick={props.onClick}
      tooltipText={props.tooltipText}
      displayHandleAsHovered={props.isHovered}
      setDisplayHandleAsHovered={props.setIsHovered}
    />
  );
}
